import { EnhancedModel } from "./enhanced.model";

export class ApplicationPersonPhoto extends EnhancedModel {
    //photo: any
    data: any
    createdDate: Date;
    photoLocation: string;
    photoMimeType: string;
    livenessIndicator: boolean = false;

    public get photo(): any {
        return this.data;
    }

    public set photo(value: any) {
        this.data = value;
    }

    /*public getCreatedDate(): Date {
        return this.createdDate;
    }

    public setCreatedDate(value: Date) {
        this.createdDate = value;
    }

    public getPhotoLocation(): string {
        return this.photoLocation;
    }

    public setPhotoLocation(value: string) {
        this.photoLocation = value;
    }

    public getPhotoMimeType(): string {
        return this.photoMimeType;
    }

    public setPhotoMimeType(value: string) {
        this.photoMimeType = value;
    }

    public getLivenessIndicator(): boolean {
        return this.livenessIndicator;
    }
    public setLivenessIndicator(value: boolean) {
        this.livenessIndicator = value;
    }*/

    constructor(obj: any = null) {
        super();

        if (obj !== null) {
            if (obj instanceof ApplicationPersonPhoto) {
                this.mapClone(obj);
            } else {
                this.mapJson(obj);
            }
        }
    }


    public clone() {
        const cloned = new ApplicationPersonPhoto(this);
        return cloned;
    }
    protected mapClone(obj: ApplicationPersonPhoto): void {
        this.photo = obj.photo;
        this.createdDate = obj.createdDate;
        this.photoLocation = obj.photoLocation;
        this.photoMimeType = obj.photoMimeType;
        this.livenessIndicator = obj.livenessIndicator;
    }

    protected mapJson(obj: any): void {
        if (obj.hasOwnProperty('photo')) {
            this.photo = obj.photo;
        }
        if (obj.hasOwnProperty('createdDate')) {
            this.createdDate = obj.createdDate;
        }
        if (obj.hasOwnProperty('photoLocation')) {
            this.photoLocation = obj.photoLocation;
        }
        if (obj.hasOwnProperty('photoMetadata')) {
            this.photoMimeType = obj.photoMetadata;
        }
        if (obj.hasOwnProperty('livenessIndicator')) {
            this.livenessIndicator = obj.livenessIndicator;
        }
        if (obj.hasOwnProperty('rawPhotoData')) {
            this.photo = obj.rawPhotoData;
        }
    }

}